const map = {
	"./01.jpg": 4820,
	"./02.jpg": 4531,
	"./03.jpg": 4422,
	"./04.jpg": 621,
	"./05.jpg": 3347,
	"./06.jpg": 3103,
	"./07.jpg": 1394,
	"./08.jpg": 5881,
	"./09.jpg": 5356,
	"./10.jpg": 9786,
	"./11.jpg": 1719,
	"./12.jpg": 3048,
	"./13.jpg": 7013,
	"./14.jpg": 7774,
	"./15.jpg": 7931,
	"./16.jpg": 1484,
	"./17.jpg": 9273,
	"./18.jpg": 6562
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4993;